import Bugsnag from '@bugsnag/js';
import { computed, Ref } from 'vue';

import { useBugsnag } from '@/analytics/bugsnag/composables/useBugsnag';
import { useLineColors } from '@/color/composables/useLineColors';
import Line from '@/elements/line/classes/Line';
import { Linecap } from '@/Types/types';

const { bugsnagMsgWithDebounce } = useBugsnag();

export const useLine = (line: Ref<Line>) => {
	const lineColors = useLineColors(line);

	const hasMarkers = computed(() => {
		return !!(line.value.markerStart || line.value.markerEnd);
	});

	const updateStrokeWidth = (width: number) => {
		line.value.size.height = width;
		bugsnagMsgWithDebounce(`Modify line stroke width: ${width}; ${line.value.type}-${line.value.id}`);
	};

	const updateLinecap = (linecap: Linecap) => {
		line.value.linecap = linecap;
		Bugsnag.leaveBreadcrumb(`Set line linecap ${linecap} to ${line.value.type}-${line.value.id}`);
	};

	const updateDasharray = (dasharray: number[]) => {
		line.value.dasharray = dasharray;
		Bugsnag.leaveBreadcrumb(`Set line dasharray: ${dasharray}; ${line.value.type}-${line.value.id}`);
	};

	return {
		...lineColors,
		updateStrokeWidth,
		updateLinecap,
		updateDasharray,
		hasMarkers,
	};
};
